import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "../../assets/css/modal.css";
import api from "../../seller-apis/api";
import { useAlert } from "react-alert";
var timerId;
function VerifyEmailModal(props) {
  const alert = useAlert();
  const [validEmailMsg, setValidEmailMsg] = useState(null);
  const [resendOtpDiv, setresendOtpDiv] = useState(false);
  const [verified, setVerified] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showMsg, setShowMsg] = useState("");
  const [otp, setOTP] = useState("");
  const [timer, setTimer] = useState("00:30");
  const [vendorId, setvendorId] = useState();
  const [error, setError] = useState(false);
  const [serverError, setServerError] = useState(null);

  useEffect(() => {
    setresendOtpDiv(false);
    props.show && sendOtp();
    setvendorId(localStorage.getItem("vendorId"));
    !props.show && startTimer(0);
    !props.show && setOTP("");
    !props.show && setError(false);
    !props.show && setVerified(false);
    !props.show && setShowForm(false);
    !props.show && setServerError("");
  }, [props.show]);
  function verifyMailOtp(key = 13) {
    if (key == 13) {
      setShowMsg("");
        // setShowForm(false);
        setVerified(false);
      setError(true);
      let data = {
        value: props.newEmail || props?.data?.email,
        field: "email",
        _id: vendorId,
        otp: otp,
      };
      api.auth
        .verifyField(data)
        .then((res) => {
          if (res.message == "incorrect OTP") {
            setServerError(res.message);
          } else {
            // If email was changed during onboarding, update it in backend
            if (props.emailChanged && props.newEmail) {
              api.seller.updateInfo({
                "email": props.newEmail
              })
              .then((updateRes) => {
                console.log("Email updated successfully:", updateRes);
                setShowMsg("Email verified and updated successfully");
                alert.success("Email verified and updated successfully");
                setVerified(true);
                props.updateInfo();
              
              })
              .catch((err) => {
                console.log("Error updating email:", err);
                setShowMsg("Email verified but update failed");
                setVerified(true);
              });
            } else {
              setShowMsg("Email verified successfully");
              setVerified(true);
              props.updateInfo();
            }
          }
        })
        .catch((err) => console.log(err));
    }
  }
  function sendOtp() {
    let data = {
      field: "email",
      value: props.newEmail || props?.data?.email,
      _id: vendorId,
    };

    api.auth.verifyField(data).then((res) => {
      // console.log(res);
      // setVerified(true);
      if (res.message == "email Already registerd") {
        setShowMsg("Email already registerd");
        setShowForm(true);
        setVerified(true);
      } else {
        setShowForm(true);
        startTimer();
        setVerified(false);
      }
    });
  }

  const startTimer = (time = 11) => {
    var timeLeft = time;
    countdown();
    if (time > 0) {
      timerId = setInterval(countdown, 1000);
    }
    function countdown() {
      if (timeLeft === 0) {
        clearTimeout(timerId);
        setresendOtpDiv(true);
        setTimer("0");
      } else {
        timeLeft--;
        setTimer(timeLeft);
      }
    }
  };

  return (
    <Modal
      show={props.show}
      onHide={props.handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="personalmodal"
    >
      <Modal.Header closeButton>
        <Modal.Title className="header-title">Verify Email</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {showForm ?
      <>
        {!verified ? (
          <div>
            <div class="otp-title">Enter OTP</div>
            <div className="otp-container">
              <span>Sent to : </span>
              <p>{props.newEmail || props?.data?.email}</p>
            </div>
            <div className="otp-container">
              <input
                type="number"
                value={otp}
                onChange={(e) => {
                  setOTP(e.target.value);
                }}
                onKeyUp={(e) => {
                  verifyMailOtp(e.keyCode);
                }}
                className="name-cast otp-input w-100"
              />
            </div>
            <div className="text-danger fs-10">
              {error && otp.length != 4 ? "Please enter a valid otp" : ""}
            </div>
            <div className="text-danger fs-10">
              {error && otp.length == "" ? "Please enter otp" : ""}
            </div>
            <div className="text-danger fs-10">
              {serverError ? serverError : ""}
            </div>
            <div style={{ padding: 10, textAlign: "center" }}>
              <div className="resend-otp text-center">
                00:{timer < 10 ? "0" : ""}
                {timer}{" "}
                {resendOtpDiv ? (
                  <strong
                    onClick={() => {
                      sendOtp();
                    }}
                  >
                    Resend OTP
                  </strong>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="text-center">
              <button
                disabled={otp == null || otp.length != 4}
                onClick={() => verifyMailOtp(13)}
                class="profile-but"
              >
                Proceed
              </button>
            </div>
          </div>
        ) : (
          <div>
            <div class={`alert ${showMsg=="Email already registerd"?'alert-danger':'alert-success'} text-center`} role="alert">
              {showMsg}
            </div>
            <div className="text-center">
              <button
                class="profile-but"
                onClick={() => {
                  props.updateInfo();
                  props.handleClose();
                }}
              >
                Ok
              </button>
            </div>
          </div>
        )}</>:
        <><div class="alert alert-success text-center" role="alert">
        Loading...
      </div></>}
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
}
export default VerifyEmailModal;
